import { useQuery } from "@tanstack/react-query"
import { actionRequestsQuery } from "../lib/actionRequestsQuery"

export function useActionRequestsQuery(...args: Parameters<typeof actionRequestsQuery>) {
  return useQuery(actionRequestsQuery(...args))
}
